/* eslint-disable no-void */
import {
  Autocomplete as MuiAutocomplete,
  createFilterOptions,
} from '@material-ui/lab'
import { TextField } from '@material-ui/core'

import { isArray, isEqual, isString } from 'lodash'
import PropTypes from 'prop-types'
import { memo, useCallback, useEffect, useState } from 'react'
import { autoComplete } from '../api'

const AutoComplete = ({
  metodo,
  codigo,
  label,
  value,
  textFieldProps,
  onChange = (e) => void e,
  getOptionLabel,
  searchParams,
  filterFunction,
  helperText,
  ...props
}) => {
  const [lista, setLista] = useState([])
  const [inputValue, setInputValue] = useState('')

  const buscar = useCallback(
    async (valor) => {
      const res = await autoComplete(
        metodo,
        { value: valor || inputValue, ...searchParams },
        codigo,
      )
      setLista(res.result || [])
    },
    [codigo, inputValue, metodo, searchParams],
  )

  useEffect(() => {
    if (isString(value)) buscar(value)
  }, [buscar, value])

  useEffect(() => {
    // if (inputValue.length < 2) return;
    buscar()
  }, [inputValue, buscar])

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => JSON.stringify(option),
    ignoreAccents: true,
    ignoreCase: true,
  })

  return (
    <MuiAutocomplete
      options={
        isArray(value)
          ? lista.filter((v) =>
              filterFunction
                ? filterFunction(v, value)
                : !isEqual(v[0], value[0]),
            )
          : lista
      }
      getOptionSelected={(o, v) => o[0] === v}
      getOptionLabel={getOptionLabel || ((option) => option?.at(1))}
      noOptionsText={
        inputValue.length < 2 ? 'Digite para pesquisar' : 'Não Encontrado'
      }
      clearText="Limpar"
      openText="Abrir"
      onInputChange={(e) => setInputValue(e?.target?.value || '')}
      filterSelectedOptions
      autoComplete
      autoHighlight
      {...{ value, onChange, filterOptions }}
      {...props}
      renderInput={(params) => {
        // Ajuste explícito do `InputLabelProps` no renderInput
        params.InputProps.startAdornment = (
          <>{params.InputProps.startAdornment}</>
        )
        return (
          <TextField
            fullWidth
            variant="outlined"
            margin="none"
            InputLabelProps={{ shrink: true }}
            style={{ marginTop: 8 }}
            label={label}
            helperText={helperText}
            FormHelperTextProps={{
              style: {
                color: '#d32f2f', // Altera a cor do helperText
              },
            }}
            {...textFieldProps}
            {...params}
          />
        )
      }}
    />
  )
}

AutoComplete.propTypes = {
  metodo: PropTypes.string.isRequired,
  codigo: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.array,
  searchParams: PropTypes.object,
  onChange: PropTypes.func,
  getOptionLabel: PropTypes.func,
  textFieldProps: PropTypes.object,
  filterFunction: PropTypes.func,
}

export default memo(AutoComplete, isEqual)
